var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 5.21875C11.6719 5.42969 12 5.99219 12 6.625C12 7.28125 11.6719 7.84375 11.25 8.05469V11.5C11.25 11.8047 11.0625 12.0859 10.7812 12.2031C10.5 12.3203 10.1719 12.25 9.96094 12.0391L8.92969 11.0078C7.80469 9.88281 6.28125 9.25 4.6875 9.25H4.5V12.25C4.5 12.6719 4.14844 13 3.75 13H2.25C1.82812 13 1.5 12.6719 1.5 12.25V9.25C0.65625 9.25 0 8.59375 0 7.75V5.5C0 4.67969 0.65625 4 1.5 4H4.6875C6.28125 4 7.80469 3.36719 8.92969 2.26562L9.96094 1.23438C10.1719 1.02344 10.5 0.953125 10.7812 1.07031C11.0625 1.1875 11.25 1.46875 11.25 1.75V5.21875ZM4.6875 5.5H4.5V7.75H4.6875C6.5625 7.75 8.36719 8.45312 9.75 9.71875V3.55469C8.36719 4.82031 6.5625 5.5 4.6875 5.5Z",
    fill: "#D6D8E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoneIcon);
export default __webpack_public_path__ + "static/media/fone-icon.faeda0d22d928d0e808911248ab660f9.svg";
export { ForwardRef as ReactComponent };